export default "__VITE_ASSET__6e16ea8a__"